module.exports = __webpack_public_path__ + "img/3x.a5113c3.jpg";